import { all_routes } from '../Router/all_routes';

// Helper function to generate route with shop ID
export const generateRoute = (routeName, shopId = 'all') => {
  const baseRoute = all_routes[routeName];
  if (!baseRoute) return '/';

  return baseRoute.replace(':shopId', shopId);
};

// Helper function to get shop ID from current URL
export const getShopIdFromUrl = () => {
  const pathParts = window.location.pathname.split('/').filter(part => part !== '');
  const shopId = pathParts[0];

  // Return 'all' if no shop ID found, or if it's a known non-shop route
  const nonShopRoutes = ['signin', 'register', 'forgot-password', 'error-404', 'error-500'];
  if (!shopId || nonShopRoutes.includes(shopId)) {
    return 'all';
  }

  return shopId;
};

// Helper function to navigate with current shop ID
export const navigateWithShopId = (routeName, navigate, customShopId = null) => {
  const shopId = customShopId || getShopIdFromUrl();
  const route = generateRoute(routeName, shopId);
  navigate(route);
};

export default {
  generateRoute,
  getShopIdFromUrl,
  navigateWithShopId
};